import React, { useState, useEffect, Fragment, useRef } from 'react';
import { useAlert } from 'react-alert';
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../../utils/permissionAuth';
import { useNavigate } from 'react-router-dom';
import * as XLSX from 'xlsx';
import Page from 'src/components/Page';
import { Box, Button, Card, CardContent, CardHeader, Container, Grid, InputLabel, makeStyles, MenuItem, Paper, Table, TableBody, TableCell, TableContainer, TableRow, TextField, Typography } from '@material-ui/core';
import { Formik } from 'formik';
import PerfectScrollbar from 'react-perfect-scrollbar';
import DateFnsUtils from '@date-io/date-fns';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { LoadingComponent } from 'src/utils/newLoader';
import tokenService from '../../../../utils/tokenDecoder';
import services from '../Services';
import * as Yup from 'yup';
import ReactToPrint from 'react-to-print';
import CreatePDF from './CreatePDF';


const screenCode = 'COPREPORTNEW';

const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    colorCancel: {
        backgroundColor: 'red'
    },
    colorRecord: {
        backgroundColor: 'green'
    }
}));

export default function COPReportNew() {
    const alert = useAlert();
    const navigate = useNavigate();
    const classes = useStyles();
    const componentRef = useRef();
    const [GroupList, setGroupList] = useState([]);
    const [FactoryList, setFactoryList] = useState();
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [title, setTitle] = useState('COP Report New');
    const [IsReportVisible, setIsReportVisible] = useState(false);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupID: 0,
        factoryID: 0,
        applicableMonth: '',
        applicableMonthName: '',
        applicableYear: '',
        noOfUnits: 1,
        teaQuantity: 0, 
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false,
    });
    const [reportData, setReportData] = useState({
        GreenLeafExpenses: 0,
        Blarrearas: 0,
        LeafTransportation: 0,
        FactoryStaffSalary: 0,
        FactoryLabourPayment: 0,
        Bonus: 0,
        TeaAndMealsExpenses: 0,
        TransportOfWorkers: 0,
        Power: 0,
        FuelFirewood: 0,
        MaintenanceAndUpkeep: 0,
        PaperBag: 0,
        SundryExpenses: 0,
        GeneratorMaintenance: 0,
        JMC_Tata_Bolero: 0,
        OfficeStaffSalary: 0,
        FactoryLicense: 0,
        UpkeepofBungalow_Quarters: 0,
        Charity_Donation: 0,
        WaterSupply: 0,
        Welfare_Sports: 0,
        Travelling: 0,
        Communication: 0,
        Postage_Printing_Stationaries: 0,
        OfficeUpkeep: 0,
        OtherExpenses: 0,
        TeaSaleExpenses: 0,
        MadeTeaTransportation: 0,
        BankCharges: 0,
        ODInterest: 0,
        BrokerAdvanceInterest: 0,
        BankLoanInterest: 0,
        PrimeCost: 0,
        TotalFactoryOverhead: 0,
        TotalCostofManufacture: 0,
        TotalExpenses: 0,
        TotalTeaSaleExpenses: 0,
        TotalFinancialExpenses: 0,
        GrandTotalExpenses: 0,
        NetSaleAverage: 0,
        Variance: 0,
    });
    const [copValues, setCopValues] = useState({
        GreenLeafExpenses: 0,
        Blarrearas: 0,
        LeafTransportation: 0,
        FactoryStaffSalary: 0,
        FactoryLabourPayment: 0,
        Bonus: 0,
        TeaAndMealsExpenses: 0,
        TransportOfWorkers: 0,
        Power: 0,
        FuelFirewood: 0,
        MaintenanceAndUpkeep: 0,
        PaperBag: 0,
        SundryExpenses: 0,
        GeneratorMaintenance: 0,
        JMC_Tata_Bolero: 0,
        OfficeStaffSalary: 0,
        FactoryLicense: 0,
        UpkeepofBungalow_Quarters: 0,
        Charity_Donation: 0,
        WaterSupply: 0,
        Welfare_Sports: 0,
        Travelling: 0,
        Communication: 0,
        Postage_Printing_Stationaries: 0,
        OfficeUpkeep: 0,
        OtherExpenses: 0,
        TeaSaleExpenses: 0,
        MadeTeaTransportation: 0,
        BankCharges: 0,
        ODInterest: 0,
        BrokerAdvanceInterest: 0,
        BankLoanInterest: 0,
        PrimeCost: 0,
        TotalFactoryOverhead: 0,
        TotalCostofManufacture: 0,
        TotalExpenses: 0,
        TotalTeaSaleExpenses: 0,
        TotalFinancialExpenses: 0,
        GrandTotalExpenses: 0,
        NetSaleAverage: 0,
        Variance: 0,
    });

    useEffect(() => {
        trackPromise(getPermission());
        trackPromise(getGroupsForDropdown());
    }, []);

    useEffect(() => {
        trackPromise(getFactoriesForDropDown());
        handleDateChange(new Date());
    }, [selectedSearchValues.groupID]);

    async function getPermission() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(
            p => p.permissionCode == 'VIEWCOPREPORTNEW'
        );
        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(
            p => p.permissionCode == 'GROUPDROPDOWN'
        );
        var isFactoryFilterEnabled = permissions.find(
            p => p.permissionCode == 'FACTORYDROPDOWN'
        );

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
        });

        setSelectedSearchValues({
            ...selectedSearchValues,
            groupID: parseInt(tokenService.getGroupIDFromToken()),
            factoryID: parseInt(tokenService.getFactoryIDFromToken())
        });
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroupList(groups);
    }

    async function getFactoriesForDropDown() {
        const factory = await services.getFactoryByGroupID(
            selectedSearchValues.groupID
        );
        setFactoryList(factory);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function GenerateReport() {
         if (selectedSearchValues.noOfUnits == '' && !/^\d+$/.test(selectedSearchValues.noOfUnits)) {
            alert.error('INVALID NO OF UNITS');
            return;
        }
        let model = {
            groupID: parseInt(selectedSearchValues.groupID),
            factoryID: parseInt(selectedSearchValues.factoryID),
            applicableMonth: parseInt(selectedSearchValues.applicableMonth),
            applicableYear: parseInt(selectedSearchValues.applicableYear),
            noOfUnits: parseInt(selectedSearchValues.noOfUnits),
            teaQuantity: parseInt(selectedSearchValues.teaQuantity),
      }
      const response = await services.GetCOPReportNewDetails(model);
        if (!response.data || Object.values(response.data).every(val => Number(val) === 0)) {
            alert.error('No records to display');
            setIsReportVisible(false);
            return;
        }
        await addDatatoReportData(response.data);
        setIsReportVisible(true);
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value;
        setSelectedSearchValues({
            ...selectedSearchValues,
            [e.target.name]: value
        });
        if (target.name === 'groupID') {
            setSelectedSearchValues({
                ...selectedSearchValues,
                [e.target.name]: value,
                factoryID: 0,
            });
        }
    }

    async function addDatatoReportData(data) {
       setReportData({
            GreenLeafExpenses: Number(data.greenLeafExpenses) || 0,
            Blarrearas: Number(data.blarrearas) || 0,
            LeafTransportation: Number(data.leafTransportation) || 0,
            FactoryStaffSalary: Number(data.factoryStaffSalary) || 0,
            FactoryLabourPayment: Number(data.factoryLabourPayment) || 0,
            Bonus: Number(data.bonus) || 0,
            TeaAndMealsExpenses: Number(data.teaAndMealsExpenses) || 0,
            TransportOfWorkers: Number(data.transportOfWorkers) || 0,
            Power: Number(data.power) || 0,
            FuelFirewood: Number(data.fuelFirewood) || 0,
            MaintenanceAndUpkeep: Number(data.maintenanceAndUpkeep) || 0,
            PaperBag: Number(data.paperBag) || 0,
            SundryExpenses: Number(data.sundryExpenses) || 0,
            GeneratorMaintenance: Number(data.generatorMaintenance) || 0,
            JMC_Tata_Bolero: Number(data.jmC_Tata_Bolero) || 0,
            OfficeStaffSalary: Number(data.officeStaffSalary) || 0,
            FactoryLicense: Number(data.factoryLicense) || 0,
            UpkeepofBungalow_Quarters: Number(data.upkeepofBungalow_Quarters) || 0,
            Charity_Donation: Number(data.charity_Donation) || 0,
            WaterSupply: Number(data.waterSupply) || 0,
            Welfare_Sports: Number(data.welfare_Sports) || 0,
            Travelling: Number(data.travelling) || 0,
            Communication: Number(data.communication) || 0,
            Postage_Printing_Stationaries: Number(data.postage_Printing_Stationaries) || 0,
            OfficeUpkeep: Number(data.officeUpkeep) || 0,
            OtherExpenses: Number(data.otherExpenses) || 0,
            TeaSaleExpenses: Number(data.teaSaleExpenses) || 0,
            MadeTeaTransportation: Number(data.madeTeaTransportation) || 0,
            BankCharges: Number(data.bankCharges) || 0,
            ODInterest: Number(data.odInterest) || 0,
            BrokerAdvanceInterest: Number(data.brokerAdvanceInterest) || 0,
            BankLoanInterest: Number(data.bankLoanInterest) || 0,
            PrimeCost: Number(data.primeCost) || 0,
            TotalFactoryOverhead: Number(data.totalFactoryOverhead) || 0,
            TotalCostofManufacture: Number(data.totalCostofManufacture) || 0,
            TotalExpenses: Number(data.totalExpenses) || 0,
            TotalTeaSaleExpenses: Number(data.totalTeaSaleExpenses) || 0,
            TotalFinancialExpenses: Number(data.totalFinancialExpenses) || 0,
            GrandTotalExpenses: Number(data.grandTotalExpenses) || 0,
            NetSaleAverage: Number(data.netSaleAverage) || 0,
            Variance: Number(data.variance) || 0,
        });
        setCopValues({
            GreenLeafExpenses: Number(data.greenLeafExpenses) / selectedSearchValues.noOfUnits || 0,
            Blarrearas: Number(data.blarrearas) / selectedSearchValues.noOfUnits || 0,
            LeafTransportation: Number(data.leafTransportation) / selectedSearchValues.noOfUnits || 0,
            FactoryStaffSalary: Number(data.factoryStaffSalary) / selectedSearchValues.noOfUnits || 0,
            FactoryLabourPayment: Number(data.factoryLabourPayment) / selectedSearchValues.noOfUnits || 0,
            Bonus: Number(data.bonus) / selectedSearchValues.noOfUnits || 0,
            TeaAndMealsExpenses: Number(data.teaAndMealsExpenses) / selectedSearchValues.noOfUnits || 0,
            TransportOfWorkers: Number(data.transportOfWorkers) / selectedSearchValues.noOfUnits || 0,
            Power: Number(data.power) / selectedSearchValues.noOfUnits || 0,
            FuelFirewood: Number(data.fuelFirewood) / selectedSearchValues.noOfUnits || 0,
            MaintenanceAndUpkeep: Number(data.maintenanceAndUpkeep) / selectedSearchValues.noOfUnits || 0,
            PaperBag: Number(data.paperBag) / selectedSearchValues.noOfUnits || 0,
            SundryExpenses: Number(data.sundryExpenses) / selectedSearchValues.noOfUnits || 0,
            GeneratorMaintenance: Number(data.generatorMaintenance) / selectedSearchValues.noOfUnits || 0,
            JMC_Tata_Bolero: Number(data.jmC_Tata_Bolero) / selectedSearchValues.noOfUnits || 0,
            OfficeStaffSalary: Number(data.officeStaffSalary) / selectedSearchValues.noOfUnits || 0,
            FactoryLicense: Number(data.factoryLicense) / selectedSearchValues.noOfUnits || 0,
            UpkeepofBungalow_Quarters: Number(data.upkeepofBungalow_Quarters) / selectedSearchValues.noOfUnits || 0,
            Charity_Donation: Number(data.charity_Donation) / selectedSearchValues.noOfUnits || 0,
            WaterSupply: Number(data.waterSupply) / selectedSearchValues.noOfUnits || 0,
            Welfare_Sports: Number(data.welfare_Sports) / selectedSearchValues.noOfUnits || 0,
            Travelling: Number(data.travelling) / selectedSearchValues.noOfUnits || 0,
            Communication: Number(data.communication) / selectedSearchValues.noOfUnits || 0,
            Postage_Printing_Stationaries: Number(data.postage_Printing_Stationaries) / selectedSearchValues.noOfUnits || 0,
            OfficeUpkeep: Number(data.officeUpkeep) / selectedSearchValues.noOfUnits || 0,
            OtherExpenses: Number(data.otherExpenses) / selectedSearchValues.noOfUnits || 0,
            TeaSaleExpenses: Number(data.teaSaleExpenses) / selectedSearchValues.noOfUnits || 0,
            MadeTeaTransportation: Number(data.madeTeaTransportation) / selectedSearchValues.noOfUnits || 0,
            BankCharges: Number(data.bankCharges) / selectedSearchValues.noOfUnits || 0,
            ODInterest: Number(data.odInterest) / selectedSearchValues.noOfUnits || 0,
            BrokerAdvanceInterest: Number(data.brokerAdvanceInterest) / selectedSearchValues.noOfUnits || 0,
            BankLoanInterest: Number(data.bankLoanInterest) / selectedSearchValues.noOfUnits || 0,
            PrimeCost: Number(data.primeCost) / selectedSearchValues.noOfUnits || 0,
            TotalFactoryOverhead: Number(data.totalFactoryOverhead) / selectedSearchValues.noOfUnits || 0,
            TotalCostofManufacture: Number(data.totalCostofManufacture) / selectedSearchValues.noOfUnits || 0,
            TotalExpenses: Number(data.totalExpenses) / selectedSearchValues.noOfUnits || 0,
            TotalTeaSaleExpenses: Number(data.totalTeaSaleExpenses) / selectedSearchValues.noOfUnits || 0,
            TotalFinancialExpenses: Number(data.totalFinancialExpenses) / selectedSearchValues.noOfUnits || 0,
            GrandTotalExpenses: Number(data.grandTotalExpenses) / selectedSearchValues.noOfUnits || 0,
            NetSaleAverage: Number(data.netSaleAverage) / selectedSearchValues.teaQuantity || 0,
            Variance: Number(data.variance) / selectedSearchValues.noOfUnits || 0,
        });
    }

    async function handleDateChange(date) {
        let monthNames = ["JAN", "FEB", "MARCH", "APRIL", "MAY", "JUNE", "JULY", "AUG", "SEPT", "OCT", "NOV", "DEC"];
        var month = date.getUTCMonth() + 1;
        var year = date.getUTCFullYear();
        let monthName = monthNames[month - 1];
        setSelectedSearchValues({
            ...selectedSearchValues,
            applicableMonthName: monthName,
            applicableMonth: month,
            applicableYear: year
        })
        if (selectedDate != null) {
            var prevMonth = selectedDate.getUTCMonth() + 1
            var prevyear = selectedDate.getUTCFullYear();
            if ((prevyear == year && prevMonth != month) || (prevyear != year)) {
                setSelectedDate(date)
            }
        } else {
            setSelectedDate(date)
        }
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
            </Grid>
        );
    }

    async function createDataForExcelFromRows() {
        let monthYear = selectedSearchValues.applicableMonthName + ' - ' + selectedSearchValues.applicableYear
        const aoa = [
            [GroupList[selectedSearchValues.groupID] + ' ' + FactoryList[selectedSearchValues.factoryID], '', '', ''],
            ['COP Report of ' + selectedSearchValues.applicableMonthName + ', ' + selectedSearchValues.applicableYear, '', '', ''],
            ['Expenses', '', monthYear, ''],
            ['', '', 'Expenses', 'COP'],
            ['Made Tea', '', '' ,Number(selectedSearchValues.noOfUnits)],
            ['Cost of Sales', '', '', ''],
            ['Green Leaf Expenses', '', reportData.GreenLeafExpenses, copValues.GreenLeafExpenses],
            ['Bl Arrearas', '', reportData.Blarrearas, copValues.Blarrearas],
            ['Leaf Transportation - Estate Vehicles', '', reportData.LeafTransportation, copValues.LeafTransportation],
            ['Prime Cost', '', reportData.PrimeCost, copValues.PrimeCost],
            ['Add Factory Overhead', '', '', ''],
            ['Factory Staff Salary', '', reportData.FactoryStaffSalary, copValues.FactoryStaffSalary],
            ['Factory Labour Payment', '', reportData.FactoryLabourPayment, copValues.FactoryLabourPayment],
            ['Bonus', '', reportData.Bonus, copValues.Bonus],
            ['Tea & Meals Expenses', '', reportData.TeaAndMealsExpenses, copValues.TeaAndMealsExpenses],
            ['Transport of Workers', '', reportData.TransportOfWorkers, copValues.TransportOfWorkers],
            ['Power', '', reportData.Power, copValues.Power],
            ['Fuel Firewood', '', reportData.FuelFirewood, copValues.FuelFirewood],
            ['Maintenance & Upkeep', '', reportData.MaintenanceAndUpkeep, copValues.MaintenanceAndUpkeep],
            ['Paper Bag', '', reportData.PaperBag, copValues.PaperBag],
            ['Sundry Expenses', '', reportData.SundryExpenses, copValues.SundryExpenses],
            ['Genarator Maintenance', '', reportData.GeneratorMaintenance, copValues.GeneratorMaintenance],
            ['JMC, Tata, Bolero', '', reportData.JMC_Tata_Bolero, copValues.JMC_Tata_Bolero],
            ['Total Factory Overhead', '', reportData.TotalFactoryOverhead, copValues.TotalFactoryOverhead],
            ['Total Cost of Manufacture', '', reportData.TotalCostofManufacture, copValues.TotalCostofManufacture],
            ['', '', '', ''],
            ['Less - Expenses', '', '', ''],
            ['Office Staff Salary', '', reportData.OfficeStaffSalary, copValues.OfficeStaffSalary],
            ['Factory License', '', reportData.FactoryLicense, copValues.FactoryLicense],
            ['Upkeep of Bungalow & Quarters', '', reportData.UpkeepofBungalow_Quarters, copValues.UpkeepofBungalow_Quarters],
            ['Charity & Donation', '', reportData.Charity_Donation, copValues.Charity_Donation],
            ['Water Supply', '', reportData.WaterSupply, copValues.WaterSupply],
            ['Welfare & Sports', '', reportData.Welfare_Sports, reportData.Welfare_Sports],
            ['Travelling', '', reportData.Travelling, copValues.Travelling],
            ['Communication', '', reportData.Communication, copValues.Communication],
            ['Postage, Printing & Stationaries', '', reportData.Postage_Printing_Stationaries, copValues.Postage_Printing_Stationaries],
            ['Office Upkeep', '', reportData.OfficeUpkeep, copValues.OfficeUpkeep],
            ['Other Expenses', '', reportData.OtherExpenses, copValues.OtherExpenses],
            ['Total Expenses', '', reportData.TotalExpenses, copValues.TotalExpenses],
            ['', '', '', ''],
            ['Less - Tea Sales Expenses', '', '', ''],
            ['Tea Sale Expenses', '', reportData.TeaSaleExpenses, copValues.TeaSaleExpenses],
            ['Made Tea Transportation', '', reportData.MadeTeaTransportation, copValues.MadeTeaTransportation],
            ['Total Tea Sale Expenses', '', reportData.TotalTeaSaleExpenses, copValues.TotalTeaSaleExpenses],
            ['', '', '', ''],
            ['Less - Financial & Other Expenses', '', '', ''],
            ['Bank Charges', '', reportData.BankCharges, copValues.BankCharges],
            ['OD Interest', '', reportData.ODInterest, copValues.ODInterest],
            ['Broker Advance Interest', '', reportData.BrokerAdvanceInterest, copValues.BrokerAdvanceInterest],
            ['Bank Loan Interest', '', reportData.BankLoanInterest, copValues.BankLoanInterest],
            ['Total Financial Expenses', '', reportData.TotalFinancialExpenses, copValues.TotalFinancialExpenses],
            ['', '', '', ''],
            ['Total Expenses', '40', reportData.GrandTotalExpenses, copValues.GrandTotalExpenses],
            ['', '', '', ''],
            ['Net Sale Average', '41', reportData.NetSaleAverage, copValues.NetSaleAverage],
            ['', '', '', ''],
            ['Total Expenses', '40', reportData.GrandTotalExpenses, copValues.GrandTotalExpenses],
            ['Variance', '42', reportData.Variance, copValues.Variance],
        ];
        return aoa;
    }

    async function exportSimpleExcel() {
        var aoa = await createDataForExcelFromRows();
        const worksheet = XLSX.utils.aoa_to_sheet(aoa);
        worksheet['!merges'] = [
            { s: { r: 0, c: 0 }, e: { r: 0, c: 3 } },
            { s: { r: 1, c: 0 }, e: { r: 1, c: 3 } },
            { s: { r: 2, c: 0 }, e: { r: 3, c: 1 } },
            { s: { r: 2, c: 2 }, e: { r: 2, c: 3 } },
        ];
        worksheet['!cols'] = [
            { wch: 25 },
            { wch: 12 },
            { wch: 12 },
            { wch: 12 }
        ];
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'COP Report New');
        XLSX.writeFile(workbook, 'COP Report New - ' + GroupList[selectedSearchValues.groupID] + ' - ' + FactoryList[selectedSearchValues.factoryID]
            + ' - ' + selectedSearchValues.applicableMonthName + '-' + selectedSearchValues.applicableYear + '.xlsx');
    }

    const getPageMargins = () => {
        return `@media print {
            @page {
                background-color: white !important;
            }
            body {
                background-color: white !important;
            }
        }`;
    };

    const costOfSaleLabels = ['Green Leaf Expenses', 'Bl Arrearas', 'Leaf Transportation - Estate Vehicles', 'Prime Cost'];
    const costOfSaleIDs = ['2', '3', '4', '5'];
    const costOfSaleKeys = ['GreenLeafExpenses', 'Blarrearas', 'LeafTransportation', 'PrimeCost'];

    const factoryOverheadLables = ['Factory Staff Salary', 'Factory Labour Payment', 'Bonus', 'Tea & Meals Expenses', 'Transport of Workers', 'Power', 'Fuel Firewood', 'Maintenance & Upkeep', 'Paper Bag', 'Sundry Expenses', 'Genarator Maintenance', 'JMC, Tata, Bolero', 'Total Factory Overhead', 'Total Cost of Manufacture'];
    const factoryOverheadIDs = ['6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19'];
    const factoryOverheadKeys = ['FactoryStaffSalary', 'FactoryLabourPayment', 'Bonus', 'TeaAndMealsExpenses', 'TransportOfWorkers', 'Power', 'FuelFirewood', 'MaintenanceAndUpkeep', 'PaperBag', 'SundryExpenses', 'GeneratorMaintenance', 'JMC_Tata_Bolero', 'TotalFactoryOverhead', 'TotalCostofManufacture'];

    const expensesLabels = ['Office Staff Salary', 'Factory License', 'Upkeep of Bungalow & Quarters', 'Charity & Donation', 'Water Supply', 'Welfare & Sports', 'Travelling', 'Communication', 'Postage, Printing & Stationaries', 'Office Upkeep', 'Other Expenses', 'Total Expenses'];
    const expensesIDs = ['20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31'];
    const expensesKeys = ['OfficeStaffSalary', 'FactoryLicense', 'UpkeepofBungalow_Quarters', 'Charity_Donation', 'WaterSupply', 'Welfare_Sports', 'Travelling', 'Communication', 'Postage_Printing_Stationaries', 'OfficeUpkeep', 'OtherExpenses', 'TotalExpenses'];

    const teaSaleExpensesLabels = ['Tea Sale Expenses', 'Made Tea Transportation', 'Total Tea Sale Expenses'];
    const teaSaleExpensesIDs = ['32', '33', '34'];
    const teaSaleExpensesKeys = ['TeaSaleExpenses', 'MadeTeaTransportation', 'TotalTeaSaleExpenses'];

    const financialOtherExpensesLabels = ['Bank Charges', 'OD Interest', 'Broker Advance Interest', 'Bank Loan Interest' ,'Total Financial Expenses'];
    const financialOtherExpensesIDs = ['35', '36', '37', '38' , '39'];
    const financialOtherExpensesKeys = ['BankCharges', 'ODInterest', 'BrokerAdvanceInterest', 'BankLoanInterest', 'TotalFinancialExpenses'];

    const finalStatsLabels = ['Total Expenses', 'Net Sale Average', 'Variance'];
    const finalStatsIDs = ['40', '', ''];
    const finalStatsKeys = ['TotalExpenses', 'NetSaleAverage', 'Variance'];

    const cellCommonStyle = { border: '1px solid #e0e0e0', padding: '0.5rempx', paddingLeft: '1rempx', paddingRight: '1rempx', fontSize: '16px' };
    const cell10 = { ...cellCommonStyle, width: '10%' }
    const cell20 = { ...cellCommonStyle, width: '20%' };
    const cell50 = { ...cellCommonStyle, width: '50%' };
    const cell80 = { ...cellCommonStyle, width: '80%' };
    const cell100 = { ...cellCommonStyle, width: '100%' };

    return (
        <Fragment>
            <LoadingComponent />
            <Page className={classes.root} title={title}>
                <Container maxWidth={false}>
                    <Card>
                        <Formik
                            initialValues={{
                                groupID: selectedSearchValues.groupID,
                                factoryID: selectedSearchValues.factoryID,
                                noOfUnits: selectedSearchValues.noOfUnits
                            }}
                            validationSchema={Yup.object().shape({
                                groupID: Yup.number().required('Group is required').min(1, 'Group is required'),
                                factoryID: Yup.number().required('Factory is required').min(1, 'Factory is required'),
                                noOfUnits: Yup.number().transform((value, originalValue) => {
                                        return originalValue === '' ? NaN : Number(originalValue);
                                    }).typeError('No. Of Units must be a number').required('No. Of Units is required')
                            })}
                            onSubmit={() => trackPromise(
                                GenerateReport()
                            )}
                            enableReinitialize
                        >
                            {({ errors, handleBlur, handleSubmit, touched }) => (
                                <form onSubmit={handleSubmit}>
                                    <Box mt={0}>
                                        <Card>
                                            <CardHeader title={cardTitle(title)} />
                                            <PerfectScrollbar>
                                                <CardContent>
                                                    <Grid container spacing={2}>
                                                        <Grid item md={3} xs={12}>
                                                            <InputLabel shrink id="groupID">
                                                                Group *
                                                            </InputLabel>
                                                            <TextField select
                                                                error={Boolean(touched.groupID && errors.groupID)}
                                                                fullWidth
                                                                helperText={touched.groupID && errors.groupID}
                                                                name="groupID"
                                                                onBlur={handleBlur}
                                                                onChange={(e) => handleChange(e)}
                                                                value={selectedSearchValues.groupID}
                                                                variant="outlined"
                                                                id="groupID"
                                                                size='small'
                                                                disabled={!permissionList.isGroupFilterEnabled}
                                                            >
                                                                <MenuItem value="0">--Select Group--</MenuItem>
                                                                {generateDropDownMenu(GroupList)}
                                                            </TextField>
                                                        </Grid>
                                                        <Grid item md={3} xs={12}>
                                                            <InputLabel shrink id="factoryID">
                                                                Factory *
                                                            </InputLabel>
                                                            <TextField
                                                                select
                                                                error={Boolean(touched.factoryID && errors.factoryID)}
                                                                fullWidth
                                                                helperText={touched.factoryID && errors.factoryID}
                                                                size="small"
                                                                name="factoryID"
                                                                onBlur={handleBlur}
                                                                onChange={(e) => handleChange(e)}
                                                                value={selectedSearchValues.factoryID}
                                                                variant="outlined"
                                                                id="factoryID"
                                                            >
                                                                <MenuItem value="0">--Select Estate--</MenuItem>
                                                                {generateDropDownMenu(FactoryList)}
                                                            </TextField>
                                                        </Grid>
                                                        <Grid item md={3} xs={12}>
                                                            <InputLabel shrink id="noOfUnits">
                                                                Made Tea
                                                            </InputLabel>
                                                            <TextField
                                                                fullWidth
                                                                name="noOfUnits"
                                                                size='small'
                                                                error={Boolean(touched.noOfUnits && errors.noOfUnits)}
                                                                helperText={touched.noOfUnits && errors.noOfUnits}
                                                                onChange={(e) => handleChange(e)}
                                                                value={selectedSearchValues.noOfUnits}
                                                                variant="outlined"
                                                                id="noOfUnits">
                                                            </TextField>
                                                         </Grid>
                                                        <Grid item md={3} xs={12}>
                                                             <InputLabel shrink id="teaQuantity">
                                                                 Sold Tea Quantity *
                                                            </InputLabel>
                                                            <TextField
                                                                fullWidth
                                                                name="teaQuantity"
                                                                size='small'
                                                                error={Boolean(touched.teaQuantity && errors.teaQuantity)}
                                                                helperText={touched.teaQuantity && errors.teaQuantity}
                                                                onChange={(e) => handleChange(e)}
                                                                onKeyPress={(e) => {
                                                                        if (!/[0-9.]/.test(e.key)) {
                                                                        e.preventDefault();
                                                                    }
                                                                }}
                                                                value={selectedSearchValues.teaQuantity}
                                                                variant="outlined"
                                                                id="teaQuantity">
                                                            </TextField>
                                                        </Grid>
                                                         <Grid item md={3} xs={12}>
                                                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                                                <DatePicker
                                                                    autoOk
                                                                    variant="inline"
                                                                    openTo="month"
                                                                    views={["year", "month"]}
                                                                    label="Year and Month *"
                                                                    helperText="Select applicable month"
                                                                    value={selectedDate}
                                                                    onChange={(date) => handleDateChange(date)}
                                                                />
                                                            </MuiPickersUtilsProvider>
                                                        </Grid>
                                                    </Grid>
                                                    <Box display="flex" flexDirection="row-reverse" p={2}>
                                                        <Button
                                                            color="primary"
                                                            type="submit"
                                                            variant="contained"
                                                            size="small"
                                                        >
                                                            Search
                                                        </Button>
                                                    </Box>
                                                </CardContent>
                                            </PerfectScrollbar>
                                        </Card>
                                    </Box>
                                </form>
                            )}
                        </Formik>
                        <PerfectScrollbar>
                            {IsReportVisible && (
                                <Box minWidth={800}>
                                    <Typography align='center' variant='h5' style={{ paddingTop: '2rem' }}>COP Report of {selectedSearchValues.applicableMonthName}, {selectedSearchValues.applicableYear}</Typography>
                                    <TableContainer style={{ width: '80%', margin: '2rem auto', border: '1px solid #e0e0e0', borderRadius: 4 }}>
                                        <Table size="small" aria-label="simple table" style={{ borderCollapse: 'collapse', width: '100%' }}>
                                            <TableBody>
                                                                                            <TableRow>
                                                    <TableCell colSpan={2} rowSpan={2} align="center" style={cell50}><u>EXPENSES</u></TableCell>
                                                    <TableCell colSpan={2} align="center" style={cell20}>{selectedSearchValues.applicableMonthName} - {selectedSearchValues.applicableYear}</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell align="center" style={cell20}>Expenses</TableCell>
                                                    <TableCell align="center" style={cell20}>COP</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell align="left" style={cell50}>Made Tea</TableCell>
                                                    <TableCell align="center" style={cell10}></TableCell>
                                                    <TableCell align="right" style={cell20}></TableCell>
                                                    <TableCell align="right" style={cell20}>
                                                        {Number(selectedSearchValues.noOfUnits).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell colSpan={4} align="left" style={cell100}><u>Cost of Sales</u></TableCell>
                                                </TableRow>
                                                {costOfSaleKeys.map((key, rowIndex) => (
                                                    <TableRow key={rowIndex}>
                                                        <TableCell align="left" style={cell50}>
                                                            {costOfSaleLabels[rowIndex]}
                                                        </TableCell>
                                                        <TableCell align="center" style={cell10}>
                                                            {costOfSaleIDs[rowIndex]}
                                                        </TableCell>
                                                        <TableCell align="right" style={cell20}>
                                                            {reportData[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </TableCell>
                                                        <TableCell align="right" style={cell20}>
                                                            {copValues[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}

                                                <TableRow>
                                                    <TableCell colSpan={4} align="left" style={cell100}><u>Add factory overhead</u></TableCell>
                                                </TableRow>
                                                {factoryOverheadKeys.map((key, rowIndex) => (
                                                    <TableRow key={rowIndex}>
                                                        <TableCell align="left" style={cell50}>
                                                            {factoryOverheadLables[rowIndex]}
                                                        </TableCell>
                                                        <TableCell align="center" style={cell10}>
                                                            {factoryOverheadIDs[rowIndex]}
                                                        </TableCell>
                                                        <TableCell align="right" style={cell20}>
                                                            {reportData[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </TableCell>
                                                        <TableCell align="right" style={cell20}>
                                                            {copValues[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}

                                                <TableRow>
                                                    <TableCell colSpan={4} align="left" style={{ ...cell100, height: '2rem' }}></TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell colSpan={4} align="left" style={cell100}><u>Less - Expenses</u></TableCell>
                                                </TableRow>
                                                {expensesKeys.map((key, rowIndex) => (
                                                    <TableRow key={rowIndex}>
                                                        <TableCell align="left" style={cell50}>
                                                            {expensesLabels[rowIndex]}
                                                        </TableCell>
                                                        <TableCell align="center" style={cell10}>
                                                            {expensesIDs[rowIndex]}
                                                        </TableCell>
                                                        <TableCell align="right" style={cell20}>
                                                            {reportData[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </TableCell>
                                                        <TableCell align="right" style={cell20}>
                                                            {copValues[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}

                                                <TableRow>
                                                    <TableCell colSpan={4} align="left" style={{ ...cell100, height: '2rem' }}></TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell colSpan={4} align="left" style={cell100}><u>Less - Tea Sales Expenses</u></TableCell>
                                                </TableRow>
                                                {teaSaleExpensesKeys.map((key, rowIndex) => (
                                                    <TableRow key={rowIndex}>
                                                        <TableCell align="left" style={cell50}>
                                                            {teaSaleExpensesLabels[rowIndex]}
                                                        </TableCell>
                                                        <TableCell align="center" style={cell10}>
                                                            {teaSaleExpensesIDs[rowIndex]}
                                                        </TableCell>
                                                        <TableCell align="right" style={cell20}>
                                                            {reportData[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </TableCell>
                                                        <TableCell align="right" style={cell20}>
                                                            {copValues[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}

                                                <TableRow>
                                                    <TableCell colSpan={4} align="left" style={{ ...cell100, height: '2rem' }}></TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell colSpan={4} align="left" style={cell100}><u>Less - Financial & Other Expenses</u></TableCell>
                                                </TableRow>
                                                {financialOtherExpensesKeys.map((key, rowIndex) => (
                                                    <TableRow key={rowIndex}>
                                                        <TableCell align="left" style={cell50}>
                                                            {financialOtherExpensesLabels[rowIndex]}
                                                        </TableCell>
                                                        <TableCell align="center" style={cell10}>
                                                            {financialOtherExpensesIDs[rowIndex]}
                                                        </TableCell>
                                                        <TableCell align="right" style={cell20}>
                                                            {reportData[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </TableCell>
                                                        <TableCell align="right" style={cell20}>
                                                            {copValues[key].toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}

                                                <TableRow >
                                                    <TableCell align="left" style={{ ...cell50, height: '2rem' }}></TableCell>
                                                    <TableCell align="center" style={{ ...cell10, height: '2rem' }}></TableCell>
                                                    <TableCell align="right" style={{ ...cell20, height: '2rem' }}></TableCell>
                                                    <TableCell align="right" style={{ ...cell20, height: '2rem' }}></TableCell>
                                                </TableRow>
                                                        
                                                <TableRow>
                                                    <TableCell align="left" style={{ ...cell50, height: '2rem' }}></TableCell>
                                                    <TableCell align="center" style={{ ...cell10, height: '2rem' }}></TableCell>
                                                    <TableCell align="right" style={{ ...cell20, height: '2rem' }}></TableCell>
                                                    <TableCell align="right" style={{ ...cell20, height: '2rem' }}></TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell align="left" style={cell50}>Total Expenses</TableCell>
                                                    <TableCell align="center" style={cell10}>40</TableCell>
                                                    <TableCell align="right" style={cell20}>
                                                        {reportData.GrandTotalExpenses.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </TableCell>
                                                    <TableCell align="right" style={cell20}>
                                                        {copValues.GrandTotalExpenses.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell align="left" style={cell50}>Net Sale Average</TableCell>
                                                    <TableCell align="center" style={cell10}>41</TableCell>
                                                    <TableCell align="right" style={cell20}>
                                                        {reportData.NetSaleAverage.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </TableCell>
                                                    <TableCell align="right" style={cell20}>
                                                        {copValues.NetSaleAverage.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </TableCell>
                                                </TableRow>

                                                <TableRow>
                                                    <TableCell align="left" style={cell50}>Variance</TableCell>
                                                    <TableCell align="center" style={cell10}>42</TableCell>
                                                    <TableCell align="right" style={cell20}>
                                                        {reportData.Variance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </TableCell>
                                                    <TableCell align="right" style={cell20}>
                                                        {copValues.Variance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                    </TableCell>
                                                </TableRow>
                                             </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <Box display="flex" justifyContent="flex-end" p={2}>
                                        <Button
                                            color="primary"
                                            id="btnRecord"
                                            type="submit"
                                            variant="contained"
                                            style={{ marginRight: '1rem' }}
                                            className={classes.colorRecord}
                                            onClick={() => exportSimpleExcel()}
                                            size='small'
                                        >
                                            EXCEL
                                        </Button>
                                        <ReactToPrint
                                            documentTitle={'ProfitAndLossReportRTF - ' + GroupList[selectedSearchValues.groupID] + ' - ' + FactoryList[selectedSearchValues.factoryID]
                                                + ' - ' + selectedSearchValues.applicableMonthName + '-' + selectedSearchValues.applicableYear}
                                            trigger={() => (
                                                <Button
                                                    color="primary"
                                                    id="btnRecord"
                                                    type="submit"
                                                    variant="contained"
                                                    style={{ marginRight: '1rem' }}
                                                    className={classes.colorCancel}
                                                    size='small'
                                                >
                                                    PDF
                                                </Button>
                                            )}
                                            pageStyle={getPageMargins()}
                                            content={() => componentRef.current}
                                        />
                                        <div hidden={true}>
                                            <CreatePDF
                                                ref={componentRef}
                                                reportData={reportData}
                                                copValues={copValues}
                                                GroupList={GroupList}
                                                FactoryList={FactoryList}
                                                selectedSearchValues={selectedSearchValues}
                                            />
                                        </div>
                                    </Box>
                                </Box>
                            )}
                        </PerfectScrollbar>
                    </Card>
                </Container>
            </Page>
        </Fragment>
    );
}
